import styled from 'styled-components'
import { colors } from 'Styled/variables'

const matchColor = (percent: number) => {
  if (percent > 80) return colors.green
  if (percent > 50) return colors.messegesYellow1
  return colors.messegesRed
}

export const ReviewDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 16px;
`

export const ReviewDetailsTitle = styled.span`
  font-size: 10px;
  color: ${colors.mainText};
`

export const ReviewDetailsRowInfo = styled.span<{ orange?: boolean }>`
  font-size: 14px;
  line-height: 21px;
  color: ${({ orange }) => (orange ? colors.messegesYellow1 : colors.mainText)};
`

export const AddedToLabel = styled.span`
  margin-top: 16px;
  margin-bottom: 8px;
  font-size: 10px;
  font-weight: 400;
  line-height: 15px;
  color: ${colors.mainText};
`

export const AddedTo = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  &:last-child {
    border-bottom: none;
  }
`
export const AddedToPlaylist = styled.div`
  display: flex;
  align-items: center;
  margin-right: 8px;
`

export const AddedToPlaylistCover = styled.img`
  margin-right: 16px;
  width: 40px;
  height: 40px;
  border-radius: 4px;
`

export const AddedToPlaylistInfo = styled.div`
  display: flex;
  flex-direction: column;
`

export const AddedToPlaylistTitle = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: ${colors.mainText};
`

export const AddedToPlaylistScore = styled.span`
  font-size: 14px;
  font-weight: 400;
  color: ${colors.mainText};
`

export const AddedToPlaylistScoreLabel = styled.span`
  margin-right: 4px;
  font-size: 14px;
  font-weight: 400;
  color: ${colors.greyTextWhiteBg};
`

export const AddedToPercents = styled.span<{ percent: number }>`
  display: flex;
  align-items: center;
  margin-right: 8px;
  color: ${({ percent }) => matchColor(percent)};
`
